const classic = [
    {
        "name": "Classic 01",
        "id": 1,
        "type": "classic",
        "preview": "template_1_classic.png"
    },
    {
        "name": "Classic 02",
        "id": 2,
        "type": "classic",
        "preview": "template_2_classic.png"
    },
    {
        "name": "Classic 03",
        "id": 3,
        "type": "classic",
        "preview": "template_3_classic.png"
    },
    {
        "name": "Classic 04",
        "id": 4,
        "type": "classic",
        "preview": "template_4_classic.png"
    },
    {
        "name": "Classic 05",
        "id": 5,
        "type": "classic",
        "preview": "template_5_classic.png"
    },
    {
        "name": "Classic 06",
        "id": 6,
        "type": "classic",
        "preview": "template_6_classic.png"
    },
    {
        "name": "Classic 07",
        "id": 7,
        "type": "classic",
        "preview": "template_7_classic.png"
    },
    {
        "name": "Classic 08",
        "id": 8,
        "type": "classic",
        "preview": "template_8_classic.png"
    },
    {
        "name": "Classic 09",
        "id": 9,
        "type": "classic",
        "preview": "template_9_classic.png"
    },
    {
        "name": "Classic 10",
        "id": 10,
        "type": "classic",
        "preview": "template_10_classic.png"
    },
    {
        "name": "Classic 11",
        "id": 11,
        "type": "classic",
        "preview": "template_11_classic.png"
    },
    {
        "name": "Classic 12",
        "id": 12,
        "type": "classic",
        "preview": "template_12_classic.png"
    },
    {
        "name": "Classic 13",
        "id": 13,
        "type": "classic",
        "preview": "template_13_classic.png"
    },
]
export default {
    all: { ...classic },
    classic: classic.sort((a,b)=>b.id-a.id)
}